import type { ApiResponse } from 'src/common/interfaces';
import type { HeartBeatRequestBody } from 'src/common/interfaces/heartbeat';
import { apiSlice } from 'src/features/api/api-slice';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    postHeartBeat: builder.mutation<ApiResponse, HeartBeatRequestBody>({
      query: ({ ...body }) => ({
        url: '/heartbeats',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { usePostHeartBeatMutation } = extendedApiSlice;
